import React from 'react';
import { Container, Typography, Box, Paper } from '@mui/material';

function TermsOfService() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>
          Terms of Service
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Last Updated: December 16, 2025
        </Typography>

        <Box sx={{ mt: 3 }}>
          <Typography variant="h6" gutterBottom>
            1. Acceptance of Terms
          </Typography>
          <Typography variant="body1" paragraph>
            By accessing and using Gmail Helper ("the Service"), you accept and agree to be bound by these Terms of Service.
            If you do not agree to these terms, please do not use the Service.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            2. Description of Service
          </Typography>
          <Typography variant="body1" paragraph>
            Gmail Helper is a web-based tool that helps you manage your Gmail inbox by:
          </Typography>
          <ul>
            <li>Scanning your email headers to identify senders</li>
            <li>Creating filters to organize emails</li>
            <li>Deleting emails from selected senders</li>
            <li>Exporting filter configurations</li>
          </ul>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            3. User Responsibilities
          </Typography>
          <Typography variant="body1" paragraph>
            You are responsible for:
          </Typography>
          <ul>
            <li>Maintaining the security of your Google account credentials</li>
            <li>All actions taken through your account while using this Service</li>
            <li>Verifying filter rules before applying them</li>
            <li>Understanding that deleted emails cannot be recovered after 30 days in Gmail's Trash</li>
          </ul>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            4. Gmail Data Access
          </Typography>
          <Typography variant="body1" paragraph>
            This Service requires access to your Gmail account to function. By granting access, you authorize us to:
          </Typography>
          <ul>
            <li>Read email headers (sender information only, not email content)</li>
            <li>Create and delete Gmail filters</li>
            <li>Delete emails from your account (only when explicitly requested by you)</li>
          </ul>
          <Typography variant="body1" paragraph>
            You can revoke this access at any time through your Google Account Settings.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            5. Disclaimer of Warranties
          </Typography>
          <Typography variant="body1" paragraph>
            THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED. WE DO NOT WARRANT THAT:
          </Typography>
          <ul>
            <li>The Service will be uninterrupted or error-free</li>
            <li>Filters will work exactly as expected</li>
            <li>Deleted emails can be recovered</li>
            <li>The Service will meet your specific requirements</li>
          </ul>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            6. Limitation of Liability
          </Typography>
          <Typography variant="body1" paragraph>
            WE SHALL NOT BE LIABLE FOR ANY INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL, OR PUNITIVE DAMAGES,
            INCLUDING BUT NOT LIMITED TO:
          </Typography>
          <ul>
            <li>Loss of emails or data</li>
            <li>Incorrectly applied filters</li>
            <li>Gmail account access issues</li>
            <li>Delays or interruptions in service</li>
          </ul>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            7. Advertisements
          </Typography>
          <Typography variant="body1" paragraph>
            This Service is supported by advertisements. By using the Service, you agree to:
          </Typography>
          <ul>
            <li>View advertisements displayed within the Service</li>
            <li>Allow Google AdSense to use cookies for ad personalization</li>
            <li>Understand that we earn revenue from ad impressions and clicks</li>
          </ul>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            8. Google API Services User Data Policy
          </Typography>
          <Typography variant="body1" paragraph>
            This Service's use of information received from Gmail APIs adheres to{' '}
            <a href="https://developers.google.com/terms/api-services-user-data-policy" target="_blank" rel="noopener noreferrer">
              Google API Services User Data Policy
            </a>, including the Limited Use requirements.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            9. Prohibited Uses
          </Typography>
          <Typography variant="body1" paragraph>
            You agree NOT to:
          </Typography>
          <ul>
            <li>Use the Service for any illegal purpose</li>
            <li>Attempt to bypass or disable security features</li>
            <li>Reverse engineer or decompile the Service</li>
            <li>Use the Service to spam or send unsolicited emails</li>
          </ul>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            10. Termination
          </Typography>
          <Typography variant="body1" paragraph>
            We reserve the right to terminate or suspend access to the Service at any time, without notice, for any reason,
            including violation of these Terms.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            11. Changes to Terms
          </Typography>
          <Typography variant="body1" paragraph>
            We may modify these Terms at any time. Continued use of the Service after changes constitutes acceptance of
            the modified Terms.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            12. Governing Law
          </Typography>
          <Typography variant="body1" paragraph>
            These Terms shall be governed by and construed in accordance with the laws of the United States.
          </Typography>

          <Typography variant="h6" gutterBottom sx={{ mt: 3 }}>
            13. Contact Information
          </Typography>
          <Typography variant="body1" paragraph>
            For questions about these Terms, please contact us through our GitHub repository.
          </Typography>
        </Box>
      </Paper>
    </Container>
  );
}

export default TermsOfService;
